
//Import asset file(s) used by this module.
import AbstractInstaller from '../../../shared/src/ranj/app/core/AbstractInstaller.js';
import AppInstaller from '../../../shared/src/ranj/app/core/AppInstaller.js';
import AppModel from '../../../shared/src/ranj/app/core/AppModel.js';
import ContextEvent from "../../../shared/src/ranj/app/core/ContextEvent";
import ExitGameCommand from '../../../shared/src/ranj/app/core/ExitGameCommand.js';
import GameEvent from '../../../shared/src/ranj/app/core/GameEvent.js';
import LoadStartupAssetsTask from '../../../shared/src/ranj/app/startup/LoadStartupAssetsTask.js';
import SkinKeys from '../../../shared/src/ranj/app/ui/SkinKeys.js';
import InitPlatformAPIServiceTask from '../../../shared/src/ranj/equalture/platform/InitPlatformAPIServiceTask.js';
import SaveCommand from '../../../shared/src/ranj/equalture/savegame/SaveCommand.js';
import SaveEvent from '../../../shared/src/ranj/equalture/savegame/SaveEvent.js';
import InitLanguageTask from '../../../shared/src/ranj/equalture/startup/InitLanguageTask.js';
import ShowSplashScreenTask from '../../../shared/src/ranj/equalture/startup/ShowSplashScreenTask.js';
import StartGameCommand from './workingmemory/controller/StartGameCommand.js';
import InitWorkingMemoryGameTask from './workingmemory/core/InitWorkingMemoryGameTask.js';
import GameConfig from './workingmemory/model/GameConfig.js';
import GameModel from './workingmemory/model/GameModel.js';
import SaveModel from './workingmemory/model/SaveModel.js';
import TrackingController from './workingmemory/model/TrackingController.js';

import '../../assets/skins/SplashAssets.js';
import '../../assets/skins/SplashAssets_RTL.js';
import '../../assets/skins/MainAssets.js';
import '../../assets/skins/MainAssets_RTL.js';

import '../../../shared/lib/html5-software-library/src/ranj/util/CreateJSExtensions';
import DebugOutputController from '../debug/modules/debugoutput/DebugOutputController.js';
import SaveController from './workingmemory/controller/SaveController.js';
import InterruptWorkingMemoryGameCommand from './workingmemory/core/InterruptWorkingMemoryGameCommand.js';
import GameElementSkinFactory from './workingmemory/view/GameElementSkinFactory.js';

import PreloadScreenMediator from './workingmemory/view/PreloadScreenMediator.js';
import ShowPreloadScreenTask from '../../../shared/src/ranj/equalture/startup/ShowPreloadScreenTask.js';
import LoadPreloadAssetsTask from '../../../shared/src/ranj/equalture/startup/LoadPreloadAssetsTask.js';
import LoadSplashAssetsTask from '../../../shared/src/ranj/equalture/startup/LoadSplashAssetsTask.js';
import ConfigureDirectionalSkinsTask from './workingmemory/startup/ConfigureDirectionalSkinsTask.js';

export default class MinigameInstaller extends AbstractInstaller {

    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        this._addAssetGroupsToList(AppInstaller.PRELOAD_ASSET_GROUPS, "preload", "SplashAssets");
        this._addAssetGroupsToList(AppInstaller.STARTUP_ASSET_GROUPS, "sounds", "common");

        commands.add(ContextEvent.START_GAME, StartGameCommand);
        commands.add(GameEvent.EXIT, ExitGameCommand);
        commands.add(GameEvent.INTERRUPT_GAME, InterruptWorkingMemoryGameCommand);

        injector.mapClass("appModel", AppModel, true);
        injector.mapClass("gameModel", GameModel, true);
        injector.mapClass("trackingController", TrackingController, true);
        injector.mapClass("gameConfig", GameConfig, true);

        injector.mapClass("gameElementSkinFactory", GameElementSkinFactory, true);

        injector.mapValue("saveController", injector.createInstance(SaveController));
        injector.mapClass("saveModel", SaveModel, true);
        commands.add(SaveEvent.SAVE, SaveCommand);
        commands.add(SaveEvent.CLEAR, SaveCommand);

        // Load PreloadAssets and show preload screen immediately
        this._addStartupTask(LoadPreloadAssetsTask, "LoadPreloadAssetsTask", 15);
        this._addStartupTask(ShowPreloadScreenTask, "ShowPreloadScreenTask", 0, ["LoadPreloadAssetsTask"]);

        // In parallel, initialize platform API and language
        this._addStartupTask(InitPlatformAPIServiceTask, "InitPlatformAPIServiceTask", 15);
        this._addStartupTask(InitLanguageTask, "InitLanguageTask", 0, ["InitPlatformAPIServiceTask"]);

        this._addStartupTask(InitWorkingMemoryGameTask, "InitWorkingMemoryGameTask", 0, ["LoadStartupAssetsTask"]);

        // Load splash assets as soon as language is known (correct directional variant) - load progress shows on preload screen
        this._addStartupTask(LoadSplashAssetsTask, "LoadSplashAssetsTask", 15, ["InitLanguageTask"]);

        // Configure directional skins for main game assets
        this._addStartupTask(ConfigureDirectionalSkinsTask, "ConfigureDirectionalSkinsTask", 0, ["LoadSplashAssetsTask"]);
        
        // Display splash screen in directional variant appropriate to language 
        this._addStartupTask(ShowSplashScreenTask, "ShowSplashScreenTask", 0, ["ConfigureDirectionalSkinsTask"]);
        
        // Load startup (main game) assets - progress shows on splash screen
        this._addStartupTask(LoadStartupAssetsTask, "LoadStartupAssetsTask", 30, ["ConfigureDirectionalSkinsTask"]);

        SkinKeys.PRELOAD_SCREEN_SKIN = this._mapMediator(PreloadScreenMediator, lib.PreloadAssets.PreloadScreenSkin);



/////////////////////
////////////////////////////////////////////////////////////////////
//////////////////
    }

};
